"use client";

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const base_url = process.env.REACT_APP_BASE_URL;

const NewsDetailsComp = () => {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNewsById = async () => {
      try {
        const response = await fetch(`${base_url}/api/news/getNewsById/${id}`);
        const result = await response.json();

        if (!response.ok) throw new Error(result.message || "Error fetching news");

        setNews(result.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchNewsById();
  }, [id]);

  if (loading) return <p className="text-center">Loading...</p>;
  if (error) return <p className="text-danger text-center">Error: {error}</p>;

  return (
    <section className="sec_pd">
      <div className="mt-5 text-dark">
        <div className="row">
        <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap">
  <div>
    <h2 className="mb-1">{news.title}</h2>
    <p className="text-dark mb-0">Published on: {news.createdAt?.slice(0, 10)}</p>
  </div>

                {news.pdf && (
                  <div className="mt-3">
                    <a
                      href={news.pdf}
                      className="btn btn-dark text-warning"
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      Download PDF
                    </a>
                  </div>
                )}
              </div>


          <div className="col-12 text-center mb-3">
            <img
              src={news.image}
              alt="News"
              className="img-fluid rounded shadow"
              style={{ height: "500px" }}
            />
          </div>

          <div className="col-12">
            <div dangerouslySetInnerHTML={{ __html: news.content }} />
          </div>

          
        </div>

        <div className="text-end mt-4">
          <Link to="/news">
            <button type="button" className="btn signup-btn text-white border-0">
              <div
                className="swift-btn_animation d-flex justify-content-center align-items-center"
                style={{ background: "radial-gradient(circle, rgb(0,0,0), rgb(0,0,0))" }}
              >
                <p className="m-0 text-black fw-bold button_name">Back to home</p>
              </div>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NewsDetailsComp;
